<div class="view-regions">
  <div class="carousel-overflow-container">
    <div class="carousel-wrapper" (rtElementResized)="resizeBrainRegionsCarousel()">
      <owl-carousel-o [options]="carouselOptions" #brainRegionsCarousel>
        @for (carouselItem of carouselItems; track carouselItem?.id) {
          <ng-template
            carouselSlide
            id="{{carouselItem.id}}"
            [width]="carouselItem.name | defineCarouselItemWidth: window.innerWidth > 960 ? desktopStrokeStyle : mobileStrokeStyle"
          >
            <div
              class="carousel__item"
              [matTooltip]="carouselItem.unavailability_reason"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="carouselItem.is_available"
              matTooltipClass="brainkey-tooltip"
              [ngClass]="{
                'carousel__item_unavailable': !carouselItem.is_available,
                'carousel__item_active': carouselItem.id === activeSlideId
              }"
              #carouselItemElement
            >
              <button class="view-regions__button" (click)="slideClicked($event, carouselItem)">
                {{carouselItem.name}}
              </button>
            </div>
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>
</div>
